<template>
  <div>
    <b-card class="border-none px-4">
      <div class="flex justify-between items-center mb-4">
        <div>
          <h2 class="text-2xl font-semibold">Announcement</h2>
        </div>
      </div>
      <div class="flex">
        <div class="my-4 w-full flex">
          <div class="my-4 w-1/2 pr-2">
            <b-form-group label="Title:">
              <b-form-input
                v-model="title"
                placeholder="Enter your title"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="my-4 w-1/2 pl-2">
            <b-form-group label="Description 1:">
              <b-form-input
                v-model="description1"
                placeholder="Description 1"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="my-4 w-1/2 pl-2">
            <b-form-group label="Description 2:">
              <b-form-input
                v-model="description2"
                placeholder="Description 2"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>

        <!-- <button >Submit</button> -->
      </div>
      <div class="w-1/2">
        <b-form-group label="Curriculum Fee:">
          <b-form-input
            v-model="curriculumFee"
            placeholder="Enter Curriculum Fee"
          ></b-form-input>
        </b-form-group>
      </div>
      <h2 class="text-xl font-semibold">Application Close By :</h2>
      <div class="my-4 w-1/3 pr-2">
        <b-form-group label="Date:">
          <date-picker
            placeholder="Application Close By"
            v-model="closeDate"
            class="cust-wfull"
            format="DD-MM-YYYY"
            valueType="date"
          >
            <!-- :disabled-date="(date) => date < new Date()" -->
          </date-picker>
        </b-form-group>
      </div>
      <div class="my-4 w-1/3 pr-2 flex items-center">
        <el-radio v-model="status" label="active" value="active"
          >Active</el-radio
        >
        <el-radio v-model="status" label="inactive" value="inactive"
          >Inactive</el-radio
        >
      </div>

      <div class="text-center py-4">
        <button
          @click="handleSave"
          class="bg-primary px-10 py-2 rounded text-white text-l"
        >
          Save
        </button>
      </div>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { ChevronLeftIcon } from "vue-feather-icons";
import { mapState } from "vuex";

export default {
  components: {
    ChevronLeftIcon,
    DatePicker,
  },
  data() {
    return {
      title: "",
      description1: "",
      description2: "",
      closeDate: null,
      curriculumFee: "",
      status: "",
    };
  },
  async mounted() {
    await this.$store.dispatch("coach/getcoachannonce");
    this.init();
  },
  computed: {
    ...mapState("coach", {
      coachannounce: "coachannounce",
    }),
  },
  methods: {
    init() {
      this._id = this.coachannounce[0]._id;
      this.title = this.coachannounce[0].title;
      this.description1 = this.coachannounce[0].description1;
      this.description2 = this.coachannounce[0].description2;
      this.status = this.coachannounce[0].status;
      this.closeDate = this.coachannounce[0].closeDate
        ? new Date(this.coachannounce[0].closeDate)
        : null;
      this.curriculumFee = this.coachannounce[0].curriculumFee
        ? this.coachannounce[0].curriculumFee
        : 0;
    },
    async handleSave() {
      this.title = this.title.trim();
      this.description1 = this.description1.trim();
      this.description2 = this.description2.trim();
      this.curriculumFee = this.curriculumFee;
      // console.log(this.curriculumFee);
      if (
        this.title === "" ||
        this.description1 === "" ||
        this.description2 === "" ||
        this.curriculumFee === ""
      ) {
        await this.$swal({
          // text: "please add title, description, date and Time",
          text: `Please enter all the details!`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }
      // if (this.curriculumFee.includes(" ")) {
      //   await this.$swal({
      //     // text: "please add title, description, date and Time",
      //     text: `No spaces are allowed in Curriculum Fee!`,
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      if (
        !/^\d+$/.test(this.curriculumFee) &&
        isNaN(Number(this.curriculumFee))
      ) {
        await this.$swal({
          // text: "please add title, description, date and Time",
          text: `Curriculum Fee Must be Number!`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }

      let payload = {
        _id: this._id,
        title: this.title,
        description1: this.description1,
        description2: this.description2,
        curriculumFee: Number(this.curriculumFee),
        status: this.status,
        // closeDate: new Date(this.closeDate).toLocaleDateString("en-IN"),
      };

      if (this.closeDate !== null) {
        Object.assign(payload, {
          closeDate: this.closeDate,
        });
      }

      let loader;
      try {
        loader = this.$loading();
        let data = await this.$store.dispatch(
          "coach/editcoachannounce",
          payload
        );
        loader.close();
        if (data.code == 200) {
          this.$swal.fire({
            text: "Your announcement has been successfully saved",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          await this.$store.dispatch("coach/getcoachannonce");
        }
      } catch (err) {
        loader.close();
        console.log(err);
      }
    },
  },
};
</script>
